export const INSTALL_PROMPT_SNOOZED_UNTIL_KEY =
  'thetavern.installPromptSnoozedUntil';
export const INSTALL_PROMPT_NEVER_ASK_KEY =
  'thetavern.installPromptNeverAskAgain';
export const IOS_INSTALL_PROMPT_SNOOZED_UNTIL_KEY =
  'thetavern.iosInstallPromptSnoozedUntil';
export const IOS_INSTALL_PROMPT_NEVER_ASK_KEY =
  'thetavern.iosInstallPromptNeverAskAgain';

export const LEGACY_INSTALL_PROMPT_DISMISSED_AT_KEY =
  'thetavern.installPromptDismissedAt';
export const LEGACY_IOS_INSTALL_PROMPT_DISMISSED_AT_KEY =
  'thetavern.iosInstallPromptDismissedAt';

export const INSTALL_PROMPT_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

const readNumber = (storage, key) => {
  const value = Number(storage.getItem(key));

  return Number.isFinite(value) ? value : 0;
};

export const migrateLegacyDismissal = ({
  legacyKey,
  now = Date.now(),
  snoozeMs = INSTALL_PROMPT_SNOOZE_MS,
  storage = window.localStorage,
  untilKey,
}) => {
  const legacyDismissedAt = readNumber(storage, legacyKey);

  if (!legacyDismissedAt) {
    return;
  }

  const legacySnoozedUntil = legacyDismissedAt + snoozeMs;

  if (legacySnoozedUntil > now && !storage.getItem(untilKey)) {
    storage.setItem(untilKey, String(legacySnoozedUntil));
  }

  storage.removeItem(legacyKey);
};

export const isInstallPromptAllowed = ({
  neverAskKey,
  now = Date.now(),
  storage = window.localStorage,
  untilKey,
}) => {
  if (storage.getItem(neverAskKey) === 'true') {
    return false;
  }

  const snoozedUntil = readNumber(storage, untilKey);

  return !snoozedUntil || snoozedUntil <= now;
};

export const snoozeInstallPrompt = ({
  now = Date.now(),
  snoozeMs = INSTALL_PROMPT_SNOOZE_MS,
  storage = window.localStorage,
  untilKey,
}) => {
  storage.setItem(untilKey, String(now + snoozeMs));
};

export const permanentlyDismissInstallPrompt = ({
  neverAskKey,
  storage = window.localStorage,
  untilKey,
}) => {
  storage.setItem(neverAskKey, 'true');
  storage.removeItem(untilKey);
};

export const clearInstallPromptDismissals = (storage = window.localStorage) => {
  [
    INSTALL_PROMPT_SNOOZED_UNTIL_KEY,
    INSTALL_PROMPT_NEVER_ASK_KEY,
    IOS_INSTALL_PROMPT_SNOOZED_UNTIL_KEY,
    IOS_INSTALL_PROMPT_NEVER_ASK_KEY,
    LEGACY_INSTALL_PROMPT_DISMISSED_AT_KEY,
    LEGACY_IOS_INSTALL_PROMPT_DISMISSED_AT_KEY,
  ].forEach((key) => storage.removeItem(key));
};
